var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9175 8.27624L5.8515 12.9869C5.8013 13.0203 5.74298 13.0395 5.68276 13.0424C5.62253 13.0452 5.56265 13.0317 5.5095 13.0033C5.45634 12.9748 5.4119 12.9325 5.38091 12.8807C5.34991 12.829 5.33353 12.7699 5.3335 12.7096V3.28824C5.33353 3.22794 5.34991 3.16879 5.38091 3.11707C5.4119 3.06535 5.45634 3.023 5.5095 2.99455C5.56265 2.96609 5.62253 2.95258 5.68276 2.95546C5.74298 2.95834 5.8013 2.9775 5.8515 3.01091L12.9175 7.72157C12.9631 7.75201 13.0006 7.79325 13.0265 7.84163C13.0524 7.89001 13.0659 7.94404 13.0659 7.99891C13.0659 8.05378 13.0524 8.1078 13.0265 8.15618C13.0006 8.20456 12.9631 8.2458 12.9175 8.27624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play_icon.0563af590e38d2a883b3d81dba84469d.svg";
export { ForwardRef as ReactComponent };